// extracted by mini-css-extract-plugin
module.exports = {"component__holder":"RequestPerview_component__holder__5yKi0","detail__perview":"RequestPerview_detail__perview__3EGwa"};